define([
    "./automaticOptimizationViolationModal",
    "./backgroundTaskJobModule",
    "./backgroundTaskJobUrls",
    "./nlgBackgroundTaskJobSearch",
    "./BackgroundTaskJobController",
    "./backgroundTaskJobService",
], function () {
});